var currencies = require('./currencies');

var DEFAULT_CURRENCY_NAME = 'bitcoin';

function validateAddress(address, currencyNameOrSymbol, networkType) {
  var currency = currencies.getByNameOrSymbol(
    currencyNameOrSymbol || DEFAULT_CURRENCY_NAME
  );

  if (currency && currency.validator) {
    return currency.validator.isValidAddress(address, currency, networkType);
  }
  return true;
  // throw new Error(`Missing validator for currency: ${currencyNameOrSymbol}`);
}

export default validateAddress;
